import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import routes from "../../routes";

function Sidebar(props) {
  const location = useLocation();
  const navigate = useNavigate();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "sidebar-active" : "";
  };

  const activeCollapseRoute = (param) => {
    let className = "";
    for (let i = 0; i < param.length; i++) {
      if (location.pathname.indexOf(param[i]?.path) > -1) {
        className = "sidebar-active";
      }
    }
    return className;
    // return location.pathname.indexOf(routeName) > -1 ? "sidebar-active" : "";
  };
  const navigateUrl = (routeName) => {
    props?.handleNavigation(`${routeName}`);
  };

  const createLinks = (routesArr) => {
    return routesArr?.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.collapse == true) {
        return prop.views?.length > 0 ? (
          <li className={activeCollapseRoute(prop?.views)}>
            <a onClick={() => navigateUrl(`${prop.views[0]?.layout + prop.views[0]?.path}`)}  style={{cursor: "pointer"}}>
              {prop.name}
            </a>
          </li>
        ) : null;
      }
      return (
        <li className={activeRoute(prop.layout + prop.path)}>
          <a onClick={() => navigateUrl(`${prop.layout + prop.path}`)}  style={{cursor: "pointer"}}>
            {prop.name}
          </a>
        </li>
      );
    });
  };

  return (
    <>
      <ul>{createLinks(routes)}</ul>
    </>
  );
}

export default Sidebar;
